import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";  

export const getApiServerUri = () => {
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isLocalhost = window.location.hostname === 'localhost';
  const isDevEnv = process.env.NODE_ENV === 'development';

  // ✅ Only use 10.0.2.2 when NOT in development and running on Android
  if (!isDevEnv && isAndroid && isLocalhost) {
    return 'http://10.0.2.2:4000/graphql';
  }

  // ✅ Use standard localhost or env var during development
  return process.env.REACT_APP_API_SERVER_URI || 'http://localhost:4000/graphql';
};



const uri = getApiServerUri();  
const httpLink = createHttpLink({
  uri, // GraphQL server URI
});

const authLink = setContext((_, { headers }) => {
  // Retrieve the token from localStorage
  const token = localStorage.getItem("token");
  if (!token) {
    console.warn("Token is undefined or not set in localStorage!");
  }

  // Return the headers including the Authorization token
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink), // Combine authLink and httpLink
  cache: new InMemoryCache(), // Cache appConfig uration
});



export default client;
